import * as THREE from "three";
import { observationTuning } from "./observationTuning";

export const WORLD_VECTOR = new THREE.Vector3(...observationTuning.world.vector).normalize();

export function createWorldResponse(presentation: THREE.Object3D, worldVector: THREE.Vector3) {
  const anatomicalAxis = new THREE.Vector3(1, 0, 0);
  const targetOrientation = new THREE.Quaternion().setFromUnitVectors(anatomicalAxis, worldVector);
  targetOrientation.multiply(new THREE.Quaternion().setFromEuler(new THREE.Euler(...observationTuning.world.restingTilt)));
  presentation.quaternion.identity();

  return {
    update(deltaSeconds: number): void {
      const easing = 1 - Math.exp(-deltaSeconds * observationTuning.world.orientationResponse);
      presentation.quaternion.slerp(targetOrientation, easing);
    },
  };
}
